import { useState, useEffect } from 'react'
import axios from 'axios'

function Notifiche({ flag, dettagliIsOpen, pallinaRossaCheck }) {
    const [notifiche, setNotifiche] = useState([])

    const idUser = localStorage.getItem('idUser')

    async function notificaCliccata(notifica) {
        const zxc = document.getElementById(`ntfOpacity${notifica.id}`)
        const vbn = document.getElementById(`ntfPallina${notifica.id}`)

        if (vbn.style.display !== 'none') {// se la notifica è ancora da leggere (pallina rossa con dipsplay block)
            try {
                const res = await axios.get(`/setStatoNotifica/${notifica.idEvento}`)
                if (res.data.messaggio === 'stato cambiato in read') {
                    console.log('stato cambiato in read')
                    zxc.style.opacity = '1'; vbn.style.display = 'none'
                }
            }
            catch (err) { console.log(err) }
        }

        window.location.href = `/eventiDetails/${notifica.idEvento}`
    }
    useEffect(() => {
        async function getMessage() {
            const res = await axios.post(`/getCommenti`)
            if (res.data.length !== 0 && idUser) {
                const idEventi = res.data.filter(x => x.idMittente === idUser).map(item => item.idEvento)//id eventi commentati dall'utente
                const arrayPulito = [...new Set(idEventi)]//toglie gli elementi duplicati
                
                const xc = res.data
                    .filter(x => x.idMittente !== idUser)//no commenti del loggato
                    .filter(x => { return arrayPulito.includes(x.idEvento) })//eventi commentati da altri e con miei commenti precedenti
                    
                const mappa = new Map(xc.map(obj => [obj.idEvento, obj]))//tolgo elementi con idEvento ripetuto
                setNotifiche(Array.from(mappa.values()))
                pallinaRossaCheck(false)
                for(const elem of res.data.filter(x => x.idMittente !== idUser)) {
                    if (elem.stato) {// se 'stato' contiene l'IDUSER del loggato attiva la pallina rossa
                        const rt = elem.stato.split(',')
                        if (rt.includes(idUser))
                            pallinaRossaCheck(true) // se ci sono notifiche da leggere attiva la pallina rossa nella campanella Navbar 
                    }
                }
            }
        }
        getMessage()
    }, [])

    // useEffect(() => { console.log('notifiche:', notifiche) }, [notifiche])

    return (<>
        <div className={`divNotifiche${flag === 'notifiche' ? 'Aperto' : ''}`}>
            <div>
                <h2 style={{ margin: '0 0 0 1em', display: 'inline' }}>Notifiche</h2>
                <p style={{ margin: '-10px 20px 0 0', fontSize: 'xx-large', cursor: 'pointer', float: 'right' }}
                    onClick={() => { window.history.back() }}>X
                </p>
            </div>
            <div style={{ margin: '2em 0', overflowY: 'scroll', height: '86%' }}>
                {notifiche.length !== 0 ?
                    notifiche.map((notifica, index) => {
                        let ntfOpacity = '.6'; let ntfDisplay = 'none'
                        if (notifica.stato.split(',').includes(idUser)) {
                            ntfOpacity = '1'; ntfDisplay = 'inline-block'
                        }
                        return (
                            <div key={index} style={{ cursor: 'pointer' }}>
                                <div style={{ opacity: ntfOpacity, padding: '0 5px' }} id={`ntfOpacity${notifica.id}`}
                                    onClick={() => { notificaCliccata(notifica) }}
                                >
                                    <div>
                                        {notifica.fotoMittente ?
                                            <img src={`https://leuro-bucket.s3.amazonaws.com/${notifica.fotoMittente}`} alt=''
                                                style={{ borderRadius: '50%', width: '48px', height: '48px' }} />
                                            :
                                            <img src={require('../../userNotAuth/image/icons8-impostazioni-amministratore-maschio-32.png')} alt='' />
                                        }
                                    </div>
                                    <div className='ms-3'>
                                        {notifica.idMittente !== idUser ? 'Hai un commento su ' : <i>Hai commentato </i>}{notifica.nomeDestinatario}

                                        {/* ---------------- pallina rossa -------------- */}
                                        <span id={`ntfPallina${notifica.id}`} style={{
                                            width: '.5em', height: '.5em', borderRadius: '50%', backgroundColor: 'red', margin: '0 0 0 5px', display: ntfDisplay
                                        }}>
                                        </span>
                                    </div>

                                    {/* ------------ data ------------- */}
                                    <div style={{ padding: '0 5px', width: '100%', fontSize: 'small', marginBottom: '-1em' }}>
                                        {new Date(notifica.created_at).toISOString().slice(0, 10).split("-").reverse().join("-")}

                                    </div>
                                </div>
                                <hr />
                            </div>
                        )
                    })
                    : <div style={{ borderTop: '1px solid grey', width: '100%' }}>
                        <h5 style={{ margin: '1em 2em' }}>Non ci sono notifiche</h5>
                    </div>
                }
            </div>
        </div>
    </>)
}
export default Notifiche